import { env } from "./index";

/**
 * Which trading server a session command goes to. AppSync routes startTradeInSession, closePositionInSession and
 * stopTradeInSession by an optional `engine` argument: none goes to the legacy trade server, "afe" to the
 * alpha-forge-execution gateway on the dev trading server. Any other value is refused by AppSync.
 */
export const ENGINE = {
  legacy: "legacy",
  alphaForgeExecution: "afe",
};

export const ENGINE_OPTIONS = [
  // The legacy trade server, as the operator knows it.
  { label: "Node Enigma Execution", value: ENGINE.legacy },
  { label: "alpha-forge-execution", value: ENGINE.alphaForgeExecution },
];

// alpha-forge-execution runs only on the dev trading server, so the choice is offered only on the dev admin
export const isEngineChoiceShown = () => env === "dev";

/**
 * Adds the engine to a session command body. Legacy adds nothing, so a legacy body is exactly the body sent before
 * the engine choice existed; only alpha-forge-execution adds `engine: "afe"`.
 */
export function withEngine(params, engine) {
  if (engine === ENGINE.legacy) {
    return params;
  }
  if (engine === ENGINE.alphaForgeExecution) {
    return { ...params, engine: ENGINE.alphaForgeExecution };
  }
  throw new Error(`Unknown engine: ${engine}`);
}
